import React, {useEffect, useState} from "react";
import TextField from "@material-ui/core/TextField";
import {makeStyles} from "@material-ui/core/styles";
import PropTypes from "prop-types";
import FormControl from "@material-ui/core/FormControl";
import clsx from "clsx";
import InputAdornment from "@material-ui/core/InputAdornment";

const useStyles = makeStyles((theme) => ({
    textField: {
        margin: theme.spacing(1),
        color: theme.palette.primary.main
    },
    textFieldNoMargin: {
        color: theme.palette.primary.main
    },
}));

const CustomInput = ({
    type,
    name,
    value,
    label,
    error,
    helperText,
    onChange,
    required,
    readOnly,
    disabled,
    placeholder,
    variant,
    isMobile,
    onClick,
    onFocus,
    startAdornment,
    onBlur,
    multiline,
    rows,
    className,
    classNameInTextField,
    textfieldNoMargin,
    inputProps,
    ...props
}) => {

    const classes = useStyles();

    const [mobile, setMobile] = useState(isMobile);

    useEffect(() => {
        setMobile(isMobile);
    }, [isMobile]);

    const handleClick = () => {
        if (onClick) {
            onClick();
        }
    };

    const handleChange = (event) => {
        if (onChange && classNameInTextField) {
            onChange(event.target.value, event.target.name);
        }
        else if (onChange) {
            onChange(event.target.value);
        }

    };

    const handleFocus = () => {
        if (onFocus) {
            onFocus();
        }
    };

    const handleBlur = () => {
        if (onBlur) {
            onBlur();
        }
    };

    return (
        <FormControl
            fullWidth
            variant="outlined"
            className={className}
            style={mobile ? { height: "48px"} : {}}
            onClick={handleClick}
        >
            <TextField
                {...props}
                id={name}
                required={required}
                name={name}
                label={label}
                className={clsx(
                    {[classes.textField]: !textfieldNoMargin},
                    {[classes.textFieldNoMargin]: textfieldNoMargin},
                    {[className]: classNameInTextField}
                )}
                variant={variant}
                onChange={handleChange}
                onFocus={handleFocus}
                onBlur={handleBlur}
                type={type === "password" ? "password" : "text"}
                value={value}
                disabled={disabled}
                placeholder={placeholder}
                autoComplete={name}
                error={error}
                rows={rows}
                helperText={helperText}
                multiline={multiline}
                inputProps={inputProps}
                InputProps={
                    {
                        readOnly: readOnly,
                        startAdornment: (
                            !mobile && startAdornment ? (
                                <InputAdornment
                                    position="start"
                                >
                                    <>
                                        {startAdornment}
                                    </>
                                </InputAdornment>
                            ) : undefined
                        )
                    }
                }
            />
        </FormControl>
    );
};

CustomInput.defaultProps = {
    value: undefined,
    label: undefined,
    type: "text",
    variant: "outlined",
    startAdornment: null,
    readOnly: false,
    disabled: false,
    placeholder: undefined,
    isMobile: false,
    rows: 1,
    multiline: false,
    textfieldNoMargin: false
};

CustomInput.propTypes = {
    name: PropTypes.string.isRequired,
    rows: PropTypes.number,
    value: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number
    ]),
    type: PropTypes.string,
    label: PropTypes.string.isRequired,
    helperText: PropTypes.string,
    error: PropTypes.bool,
    required: PropTypes.bool,
    readOnly: PropTypes.bool,
    disabled: PropTypes.bool,
    placeholder: PropTypes.string,
    variant: PropTypes.oneOf(["filled", "outlined", "standard"]),
    isMobile: PropTypes.bool,
    multiline: PropTypes.bool,
    startAdornment: PropTypes.element,
    onChange: PropTypes.func,
    onClick: PropTypes.func,
    onFocus: PropTypes.func,
    onBlur: PropTypes.func,
    onReset: PropTypes.func,
    inputProps: PropTypes.object,
    className: PropTypes.any,
    classNameInTextField: PropTypes.bool,
    textfieldNoMargin: PropTypes.bool
};

export default CustomInput;
